import React from 'react';
import useSubjectCategoryContext from '~/contexts/subject-category';
import useLanguageContext from '~/contexts/language';
import { LanguageSelectorWrapper, LanguageLink } from '~/components/language-selector/language-selector';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { useDataFromSlug } from '~/helpers/page-data-utils';
import Dropdown, { MenuItem } from './dropdown/dropdown';
import LoginMenu from './login-menu/login-menu';
import GiveItem from '../give-item/give-item';
import { treatSpaceOrEnterAsClick } from '~/helpers/events';
import './main-menu.scss';
function DropdownOrMenuItem({ item }) {
    if (!('name' in item) && !('label' in item)) {
        return null;
    }
    if ('menu' in item) {
        return (React.createElement(Dropdown, { label: item.name, navAnalytics: `Main Menu (${item.name})` },
            React.createElement(MenusFromStructure, { structure: item.menu })));
    }
    return React.createElement(MenuItem, { label: item.label, url: item.partial_url });
}
function MenusFromStructure({ structure }) {
    return (React.createElement(React.Fragment, null, structure.map((item, index) => (React.createElement(DropdownOrMenuItem, { key: 'label' in item ? item.label : index, item: item })))));
}
function MenusFromCMS() {
    const structure = useDataFromSlug('oxmenus');
    // fetchFromCMS resolves with an {error} object (not an array) when the
    // CMS is unreachable, so a truthiness check alone lets it through to .map.
    if (!Array.isArray(structure)) {
        return null;
    }
    return React.createElement(MenusFromStructure, { structure: structure });
}
function K12MenuItem() {
    return React.createElement(MenuItem, { label: "\uD83C\uDF4E For K12 Teachers", url: "/k12" });
}
function SubjectsMenu() {
    const categories = useSubjectCategoryContext();
    const { language } = useLanguageContext();
    // This will have to be revisited if/when we implement more languages
    const otherLocale = ['en', 'es'].filter((la) => la !== language)[0];
    const { pathname } = useLocation();
    if (!categories.length) {
        return React.createElement("li", null, "Loading...");
    }
    return (React.createElement(Dropdown, { className: "subjects-dropdown", label: "Subjects", navAnalytics: "Main Menu (Subjects)" },
        categories
            .filter((obj) => obj.html !== 'K12')
            .map((obj) => (React.createElement(MenuItem, { key: obj.value, label: obj.html, url: `/subjects/${obj.value}` }))),
        pathname.startsWith('/details/books') ? null : (React.createElement(React.Fragment, null,
            React.createElement(LanguageSelectorWrapper, null,
                React.createElement(FormattedMessage, { id: "view", defaultMessage: "View" }),
                ' ',
                React.createElement(LanguageLink, { locale: otherLocale })),
            React.createElement(LanguageSelectorWrapper, null,
                React.createElement(FormattedMessage, { id: "view", defaultMessage: "View" }),
                ' ',
                React.createElement(LanguageLink, { locale: "pl" })))),
        language === 'en' ? (React.createElement(React.Fragment, null,
            React.createElement("hr", null),
            React.createElement(K12MenuItem, null))) : null));
}
// eslint-disable-next-line complexity
function navigateWithArrows(event) {
    var _a, _b, _c, _d, _e, _f;
    switch (event.key) {
        case 'ArrowRight':
            event.preventDefault();
            event.stopPropagation();
            (_c = (_b = (_a = event.target
                .closest('li')) === null || _a === void 0 ? void 0 : _a.nextElementSibling) === null || _b === void 0 ? void 0 : _b.querySelector('a')) === null || _c === void 0 ? void 0 : _c.focus();
            break;
        case 'ArrowLeft':
            event.preventDefault();
            event.stopPropagation();
            (_f = (_e = (_d = event.target
                .closest('li')) === null || _d === void 0 ? void 0 : _d.previousElementSibling) === null || _e === void 0 ? void 0 : _e.querySelector('a')) === null || _f === void 0 ? void 0 : _f.focus();
            break;
        default:
            break;
    }
    treatSpaceOrEnterAsClick(event);
}
export function MainMenuItems() {
    return (React.createElement(React.Fragment, null,
        React.createElement(SubjectsMenu, null),
        React.createElement(MenusFromCMS, null),
        React.createElement("li", { className: "give-button-item streamlined" },
            React.createElement(GiveItem, null)),
        React.createElement(LoginMenu, null)));
}
export default function MainMenu() {
    return (React.createElement("ul", { className: "nav-menu main-menu no-bullets", "data-analytics-nav": "Main Menu", onKeyDown: navigateWithArrows },
        React.createElement(MainMenuItems, null)));
}
